module.exports = __webpack_public_path__ + "static/media/nav.06fd987b.png";